import { useMediaQuery } from "react-responsive";

export const useMobileMediaQuery = () => useMediaQuery({ maxWidth: 767 });
export const useMediumMediaQuery = () => useMediaQuery({ maxWidth: 991 });
export const useLargeMediaQuery = () => useMediaQuery({ maxWidth: 1199 });
export const useXLargeMediaQuery = () => useMediaQuery({ maxWidth: 1399 });
